import { render, staticRenderFns } from "./ContactInformationPlayer.vue?vue&type=template&id=0a39a378&scoped=true"
import script from "./ContactInformationPlayer.vue?vue&type=script&lang=js"
export * from "./ContactInformationPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a39a378",
  null
  
)

export default component.exports